// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__Xoh1o","faqDescr":"styles_faqDescr__gbbmy","qas":"styles_qas__NekQr","qa":"styles_qa__ifMcp","accordionTitleLeftSide":"styles_accordionTitleLeftSide__FWjMT"};